import GLightbox from 'glightbox';

//lightbox init
const lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  slideEffect: 'fade'
});
